// extracted by mini-css-extract-plugin
export default {"qrColor":"#362044","map":"map-wrapper_map__nxu+z","mapContainer":"map-wrapper_mapContainer__LrpvW"};